export default __webpack_public_path__ + "static/media/ic-no results.c8422862.svg";